import { useGetPollsQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { pollsColumns, type PollRow } from '../constants/pollsColumns';

export const PollsList = () => {
    const {
        loading: pollsLoading,
        data: pollsData,
        error: pollsError,
        refetch,
        fetchMore,
    } = useGetPollsQuery({
        variables: { offset: 0 },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (pollsError) {
        throw new Error('Une erreur est survenue lors de la récupération des sondages');
    }

    const hasMore = pollsData?.polls.hasMore ?? false;
    const polls = pollsData?.polls.polls ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<PollRow>
                columns={pollsColumns}
                data={polls}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/poll/${row._id}`}
                hasMore={hasMore}
                isLoading={pollsLoading}
                refetch={async (vars) => {
                    await refetch({ ...vars });
                }}
                fetchMore={async (opts) => {
                    await fetchMore({ variables: opts.variables });
                }}
                emptyMessage="Aucun sondage n'a été trouvé"
            />
        </div>
    );
};
